// extracted by mini-css-extract-plugin
module.exports = {"error":"dangerError_error__257Vg","alertTriangleIcon":"dangerError_alertTriangleIcon__3pP5u","description":"dangerError_description__5Ulp_"};